import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import NumberField from 'components/number-field';
import TextField from 'components/text-field';
import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { useIsCoarsePointer, useIsMobile } from './use-projected-payments-viewport';

const useStyles = makeStyles((theme: any) => ({
  underline: {
    fontSize: theme.spacing(2),
    color: theme.palette.primary.light,
    fontWeight: 500,
    width: '100%',
    paddingLeft: theme.spacing(1),
    '&&&:before': { borderBottom: 'none' },
    '&&:after': { borderBottom: 'none' },
    '&:hover': { background: theme.palette.input.border },
  },
  helperText: {
    position: 'relative',
    fontSize: theme.spacing(1.5),
    marginLeft: theme.spacing(1),
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
  },
  wrapper: {
    minWidth: 0,
    [theme.breakpoints.down('sm')]: { width: '100%' },
    '@media (hover: none) and (pointer: coarse)': { '& .MuiInputBase-root': { minHeight: 44 } },
  },
  editButton: { padding: 0 },
  editButtonTouch: { minWidth: 44, minHeight: 44 },
}));

const InputCell = ({
  value,
  onChangeInput,
  placeholder,
  helperText,
  disabled,
  onClickEdit,
  prefix,
  thousandSeparator,
  inputClass = undefined,
  ariaLabel = undefined,
}: any) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const isCoarse = useIsCoarsePointer();
  return (
    <div className={classes.wrapper}>
      <NumberField
        naked
        placeholder={placeholder}
        value={value}
        onChange={onChangeInput}
        disabled={disabled}
        prefix={prefix}
        thousandSeparator={thousandSeparator}
        className={inputClass}
        InputProps={{
          inputProps: ariaLabel ? { 'aria-label': ariaLabel } : undefined,
          endAdornment: onClickEdit && (
            <IconButton
              aria-label={t('common:edit')}
              className={clsx(classes.editButton, (isMobile || isCoarse) && classes.editButtonTouch)}
              onClick={onClickEdit}
              size="large"
            >
              <FontAwesomeIcon icon="edit" size="xs" />
            </IconButton>
          ),
        }}
      />

      {helperText && <Typography color="secondary" className={classes.helperText}>{helperText}</Typography>}
    </div>
  );
};

export default InputCell;
